import { render } from "./ContextMenuComponent.vue?vue&type=template&id=591df052"
import script from "./ContextMenuComponent.vue?vue&type=script&lang=js"
export * from "./ContextMenuComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__